export const SELECT_OCORRENCIA = 'SELECT_OCORRENCIA'

export function selectOcorrencia(tabIndex, identifier) {
  return {
    type: SELECT_OCORRENCIA,
    payload: { tabIndex, identifier },
  }
}
